var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecretExpired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9668",
    "data-name": "Group 9668",
    transform: "translate(0 -0.42)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(0 0.42)",
    fill: "#e45858"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9615",
    "data-name": "Group 9615",
    transform: "translate(5.995 3.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7206",
    "data-name": "Rectangle 7206",
    width: 1.392,
    height: 5.567,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7207",
    "data-name": "Rectangle 7207",
    width: 1.392,
    height: 1.392,
    transform: "translate(0 6.495)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretExpired);
export default __webpack_public_path__ + "static/media/secret_expired.ae5716637e959af509b8a40873feec2b.svg";
export { ForwardRef as ReactComponent };